<ng-container *transloco="let t">
  <div class="d-flex" [class.dark-text]="isDarkText" [class.landing]="isLanding" ngbDropdown
       (openChange)="checkDropDown($event)">
    <div class="cursor-pointer d-flex align-items-center" [class.open]="isDropdownOpen && isLanding" ngbDropdownToggle>
      <span class="lng-text text-uppercase fw-normal">{{ activeLang }}</span>
      <img [src]="isDarkText ? 'assets/img/svg/arrow-down-dark.svg' : 'assets/img/svg/arrow-down-alt.svg'"
           class="d-xxl-none" alt="language" width="24" height="24">
    </div>
    <div ngbDropdownMenu aria-labelledby="languageDropdown">
      @if (activeLang !== 'hr') {
        <button ngbDropdownItem (click)="changeLang('hr')">
          <span>HR</span>
        </button>
      }
      @if (activeLang !== 'en') {
        <button ngbDropdownItem (click)="changeLang('en')">
          <span>EN</span>
        </button>
      }
      @if (activeLang !== 'slo') {
        <button ngbDropdownItem (click)="changeLang('slo')">
          <span>SLO</span>
        </button>
      }
      @if (activeLang !== 'it') {
        <button ngbDropdownItem (click)="changeLang('it')">
          <span>IT</span>
        </button>
      }
      @if (activeLang !== 'sr') {
        <button ngbDropdownItem (click)="changeLang('sr')">
          <span>SR</span>
        </button>
      }
      @if (activeLang !== 'bs') {
        <button ngbDropdownItem (click)="changeLang('bs')">
          <span>BS</span>
        </button>
      }
    </div>
  </div>
</ng-container>
